import RadioButton from "@medoma/components/RadioButton/RadioButton";
import RadioButtons from "@medoma/components/RadioButton/RadioButtons";
import { useFormContext, type FieldValues } from "react-hook-form";
import { useLingui } from "@lingui/react/macro";
import { recurringDictionary, recurringOptions } from "./schedulingModels";
import {
  useFieldErrorWithPrefix,
  useFieldPathWithPrefix,
} from "@/forms/FormFieldPathPrefixContext";
import { useIsInFinalValidationPhase } from "@/forms/AddActivity/TemplateFieldValidationContext";
import type { TemplateRecurrencePickerFields } from "@/forms/AddActivity/templateFormSchema";

export const TemplateRecurrencePicker = () => {
  const { t } = useLingui();
  const {
    formState: { errors },
    register,
  } = useFormContext<FieldValues>();

  const fieldName =
    useFieldPathWithPrefix<TemplateRecurrencePickerFields>("recurrence");
  const errorMessage = useFieldErrorWithPrefix<TemplateRecurrencePickerFields>(
    errors,
    "recurrence",
  );
  const isInFinalValidationPhase = useIsInFinalValidationPhase();

  return (
    <RadioButtons
      errorMessage={errorMessage}
      orientation="horizontal"
      legend={t`Upprepning`}
    >
      {recurringOptions.map((option) => (
        <RadioButton
          key={option}
          label={{ text: t(recurringDictionary[option]) }}
          {...register(fieldName, {
            required: isInFinalValidationPhase
              ? {
                  value: true,
                  message: t`Sätt upprepningsmönster`,
                }
              : undefined,
          })}
          value={option}
          visualStyle="framed"
        />
      ))}
    </RadioButtons>
  );
};
